export default "__VITE_ASSET__7a2ea4e0__"